import { css } from '@emotion/react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';
import type { TemplateSelectorItem } from '~/exportReport/templateSelector/exportReportTemplateSelector.helpers';

const iconStyle = css({
  fontSize: '24px',
  width: 'auto',
});

const titleStyle = css({
  fontSize: 16,
  fontWeight: 400,
  marginTop: 6,
});

const descriptionStyle = (theme: Theme) => css({
  color: theme.textColors.secondary,
  fontSize: 12,
  fontWeight: 400,
  marginTop: 2,
});

type ExportReportTemplateSelectorModalItemContentProps = Readonly<{
  item: TemplateSelectorItem;
}>;

export const ExportReportTemplateSelectorItemDescriptionComponent = ({ item }: ExportReportTemplateSelectorModalItemContentProps) => {
  const [t] = useTranslation();

  return (
    <>
      <div css={iconStyle}>
        <FontAwesomeIcon icon={item.icon} />
      </div>
      <div css={titleStyle}>
        {t(item.title)}
      </div>
      <div css={descriptionStyle}>
        {t(item.description)}
      </div>
    </>
  );
};
